import { faTrash } from '@fortawesome/free-solid-svg-icons';
import i18n from '@s20/i18n';
import { Modal } from '.';

// Defaults are resolved at show-time, not module-load, so locale changes
// after initial render still pick up the right translations.
const getDefaultSaveButtonProps = () => ({
    label: i18n.t('common:yesDelete'),
    savingLabel: i18n.t('common:deleting'),
    color: 'danger',
    icon: faTrash,
});

export class ConfirmDelete {
    static ask(options = {}) {
        const modalOptions = {
            ...options,
            SaveButtonProps: {
                ...getDefaultSaveButtonProps(),
                ...options.SaveButtonProps,
            },
        };

        return Modal.ask(modalOptions);
    }

    static show(options = {}) {
        const modalOptions = {
            ...options,
            SaveButtonProps: {
                ...getDefaultSaveButtonProps(),
                ...options.SaveButtonProps,
            },
        };

        Modal.show(modalOptions);
    }

    static hide() {
        Modal.hide();
    }
}
